import { getAboutPage, aboutRoute } from "../../../config/aboutContent.js";
import { buildAnimatedTitle } from "../../HeroTitleAnimation.js";
import { buildSectionPill } from "../../components/SectionPill.js";

export function createAboutHeroSection() {
  const { hero } = getAboutPage();
  const section = document.createElement("section");
  section.id = "hero";
  section.className = "section hero about-hero";

  const shell = document.createElement("div");
  shell.className = "section__inner hero__shell about-hero__shell";

  const grid = document.createElement("div");
  grid.className = "hero__grid about-hero__grid";

  grid.innerHTML = `
    <div class="hero__content">
      <div class="reveal">${buildSectionPill(hero.badge)}</div>
      <h1 class="hero__title">${buildAnimatedTitle(hero.titleSegments)}</h1>
      <p class="hero__subtitle reveal" style="--delay: 0.08s">${hero.subtitle}</p>
      <div class="hero__actions reveal" style="--delay: 0.16s">
        <a class="btn btn--primary" href="${hero.ctaPrimaryHref}">${hero.ctaPrimary}</a>
        <a class="btn btn--ghost" href="${hero.ctaSecondaryHref}">${hero.ctaSecondary}</a>
      </div>
    </div>

    <aside class="about-hero__panel reveal" style="--delay: 0.18s" aria-hidden="true">
      <div class="about-hero__panel-glow"></div>
      <div class="about-hero__panel-chrome">
        <span></span><span></span><span></span>
        <strong>taldel.company / about</strong>
      </div>
      <div class="about-hero__panel-body">
        <p class="about-hero__panel-kicker">${hero.panel.kicker}</p>
        <h2>${hero.panel.title}</h2>
        <p>${hero.panel.body}</p>
        <ul class="about-hero__stats">
          ${hero.panel.stats
            .map(
              (stat) => `
            <li>
              <strong>${stat.value}</strong>
              <span>${stat.label}</span>
            </li>
          `
            )
            .join("")}
        </ul>
      </div>
    </aside>
  `;

  shell.append(grid);
  section.append(shell);
  return section;
}

export { aboutRoute };
